import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { Tree } from 'primereact/tree';

import ButtonSp from '../../components/ButtonSp';

import InputTextSp from '../../components/InputTextSp';
import LabelSp from '../../components/LabelSp';
import { showMessage } from '../../components/MessageDialog';

import { errorHandle, isNumber, validateFields } from '../../util/functions';
import { ColaboradorPerfilFuncaoModel, ColaboradorPerfilModel } from '../../util/Models';
import { StateScreen } from '../constants';
import ColaboradorPerfilService from '../../services/ColaboradorPerfilService';
import FuncaoService from '../../services/FuncaoService';
import { ContainerScrool } from './styles';

function ColaboradorPerfilCrud(props) {
  ColaboradorPerfilCrud.propTypes = {
    stateScreen: PropTypes.string.isRequired,
    idSelected: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  ColaboradorPerfilCrud.defaultProps = {
    messageConfirmation: 'Confirma os dados',
    showConfirmation: false,
  };

  const { stateScreen, idSelected, onClose } = props;

  // states
  const [colaboradorPerfil, setColaboradorPerfil] = useState(new ColaboradorPerfilModel());
  const [errorLoadRecord, setErrorLoadRecord] = useState(false);
  const [itensSelecionados, setItensSelecionados] = useState({});
  const [itens, setItens] = useState([]);

  // useCallbacks
  const loadFuncoes = useCallback(async _colaboradorPerfil => {
    const it = [];
    const itSelected = {};
    const detalhe = _colaboradorPerfil?.colaboradorPerfilDetalhe || [];

    const funcoes = await FuncaoService.findGroup();
    if (Array.isArray(funcoes.items)) {
      for (let i = 0; i < funcoes.items.length; i++) {
        const element = funcoes.items[i];

        const children = [];
        let qtdAtivo = 0;

        for (let y = 0; y < element.funcoes.length; y++) {
          const ch = element.funcoes[y];
          children.push({
            key: ch.id,
            label: ch.descricao,
            data: ch.nome,
          });

          const funcaoDetalhe = detalhe.find(e => {
            return e.idFuncao === ch.id;
          });

          if (funcaoDetalhe?.ativo || false) {
            qtdAtivo++;
          }

          itSelected[ch.id] = {
            checked: funcaoDetalhe?.ativo || false,
            partialChecked: false,
          };
        }

        itSelected[element.nomeAgrupamento] = {
          checked: qtdAtivo === element.funcoes.length,
          partialChecked: qtdAtivo > 0 && qtdAtivo !== element.funcoes.length,
        };

        it.push({
          key: element.nomeAgrupamento,
          label: element.nomeAgrupamento,
          data: element.nomeAgrupamento,
          children,
        });
      }
    }

    setItens(it);
    setItensSelecionados(itSelected);
  }, []);

  const loadRecord = useCallback(
    async _id => {
      try {
        const retorno = await ColaboradorPerfilService.findById(_id);

        await loadFuncoes(retorno);

        setColaboradorPerfil(retorno);
        setErrorLoadRecord(false);
      } catch (err) {
        errorHandle(err);
        setErrorLoadRecord(true);
      }
    },
    [loadFuncoes]
  );

  // funcoes
  function viewMode() {
    return stateScreen === StateScreen.stView || errorLoadRecord;
  }

  function handleBack() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      showMessage('Confirmação', 'Abandonar mudanças?', idx => {
        if (idx === 1) {
          onClose();
        }
      });
    }
  }

  function handleSave() {
    if (stateScreen === StateScreen.stView) {
      onClose();
    } else {
      salvarRecord();
    }
  }

  function prepareRecord(record) {
    if (!Array.isArray(record.colaboradorPerfilDetalhe)) {
      record.colaboradorPerfilDetalhe = [];
    }

    const perfilDetalhe = record.colaboradorPerfilDetalhe;
    // desativa os não existentes na lista de seleção
    perfilDetalhe.forEach(e => {
      const selecionado = Object.keys(itensSelecionados).find(s => s === e.idFuncao);
      if (!selecionado) {
        e.ativo = false;
      }
    });

    if (itensSelecionados) {
      Object.keys(itensSelecionados).forEach(key => {
        if (isNumber(key)) {
          const perfilFuncao = perfilDetalhe.find(e => e.idFuncao === Number(key));
          if (perfilFuncao) {
            perfilFuncao.ativo = itensSelecionados[key].checked;
          } else {
            const colaboradorPerfilFuncao = new ColaboradorPerfilFuncaoModel();
            colaboradorPerfilFuncao.idFuncao = key;
            colaboradorPerfilFuncao.idColaboradorPerfil = record.id;
            colaboradorPerfilFuncao.idFuncao = Number(key);
            colaboradorPerfilFuncao.funcao.id = Number(key);
            colaboradorPerfilFuncao.ativo = itensSelecionados[key].checked;

            perfilDetalhe.push(colaboradorPerfilFuncao);
          }
        }
      });
    }
  }

  async function salvarRecord() {
    try {
      let retorno;
      prepareRecord(colaboradorPerfil);
      if (stateScreen === StateScreen.stInsert) {
        retorno = await ColaboradorPerfilService.insert(colaboradorPerfil);
      } else {
        retorno = await ColaboradorPerfilService.update(colaboradorPerfil);
      }
      toast.success('Registro salvo com sucesso.');
      onClose(retorno);
    } catch (err) {
      errorHandle(err);
    }
  }

  // useEffects
  useEffect(() => {
    if (stateScreen === StateScreen.stUpdate || stateScreen === StateScreen.stView) {
      loadRecord(idSelected);
    } else if (stateScreen === StateScreen.stInsert) {
      const novo = new ColaboradorPerfilModel();
      loadFuncoes(novo);
      setColaboradorPerfil(novo);
    }
  }, [loadRecord, idSelected, stateScreen, loadFuncoes]);

  // render principal
  return (
    <>
      <>
        <div className="p-col-12 p-sm-12 p-lg-12 p-fluid">
          <LabelSp>Nome</LabelSp>
          <InputTextSp
            value={colaboradorPerfil.nome}
            maxLength={100}
            required
            disabled={viewMode()}
            onChange={e => {
              setColaboradorPerfil({ ...colaboradorPerfil, nome: e.target.value });
            }}
          />
        </div>

        {colaboradorPerfil.id !== 1 ? (
          <ContainerScrool className="p-col-12 p-sm-12 p-lg-12 p-fluid">
            <LabelSp>Opções</LabelSp>
            <Tree
              value={itens}
              filter
              selectionMode="checkbox"
              selectionKeys={itensSelecionados}
              onSelectionChange={e => {
                setItensSelecionados(e?.value);
              }}
            />
          </ContainerScrool>
        ) : null}

        <div className="p-col-12 p-lg-12" style={{ textAlign: 'start' }}>
          {!viewMode() ? (
            <ButtonSp
              className="p-button-success"
              icon="pi pi-save"
              label="Salvar"
              disabled={!validateFields(colaboradorPerfil, ['nome'])}
              showConfirmation
              onClick={handleSave}
            />
          ) : null}
          <ButtonSp
            className="p-button-secondary"
            label="Voltar"
            icon="pi pi-chevron-circle-left"
            onClick={handleBack}
          />
        </div>
      </>
    </>
  );
}

export default ColaboradorPerfilCrud;
